  (function() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      const priceContainer = document.querySelector('[data-wholesale-check]');
      if (!priceContainer) return;

      const m2PerBox = parseFloat(priceContainer.dataset.m2PerBox) || 0;
      if (!m2PerBox || m2PerBox <= 0) return;

      const comparePricePerM2Cents = parseFloat(priceContainer.dataset.comparePricePerM2) || 0;
      const comparePricePerM2 = comparePricePerM2Cents / 100; // Convert from cents to dollars

      const wholesaleSqmContainer = document.querySelector('.price-per-m2-wholesale-sqm');
      const wholesaleSqmValue = wholesaleSqmContainer ? wholesaleSqmContainer.querySelector('.price-per-m2-wholesale-sqm__value') : null;
      const wholesaleSqmCompare = wholesaleSqmContainer ? wholesaleSqmContainer.querySelector('.price-per-m2-wholesale-sqm__compare') : null;

      if (!wholesaleSqmContainer || !wholesaleSqmValue) return;

      function calculateWholesaleSqm() {
        try {
          // Simply read the wholesale price - don't modify anything
          const wholesalePrice = document.querySelector('.wsaio_productPriceDiscounted');

          if (wholesalePrice && wholesalePrice.textContent) {
            // Extract wholesale price number
            const priceText = wholesalePrice.textContent.replace(/[^0-9.]/g, '');
            const wholesalePriceValue = parseFloat(priceText);

            if (wholesalePriceValue && !isNaN(wholesalePriceValue) && wholesalePriceValue > 0) {
              // Simple division: wholesale price / m2 per box
              const pricePerSqm = Math.round((wholesalePriceValue / m2PerBox) * 100) / 100;

              // Update display only
              wholesaleSqmValue.textContent = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(pricePerSqm);

              // Show compare price if it exists and is higher than wholesale per sqm
              if (wholesaleSqmCompare && comparePricePerM2 > 0 && comparePricePerM2 > pricePerSqm) {
                wholesaleSqmCompare.textContent = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(comparePricePerM2);
                wholesaleSqmCompare.style.display = 'inline';
              } else if (wholesaleSqmCompare) {
                wholesaleSqmCompare.style.display = 'none';
              }

              wholesaleSqmContainer.style.display = 'flex';

              // Hide the original price display when wholesale price is shown
              if (priceContainer) {
                priceContainer.style.display = 'none';
              }
            }
          } else {
            // Show original price if wholesale price not found
            if (priceContainer) {
              priceContainer.style.display = 'flex';
            }
            if (wholesaleSqmContainer) {
              wholesaleSqmContainer.style.display = 'none';
            }
          }
        } catch (e) {
          // Silently fail
        }
      }

      // Check immediately and once more after very short delay to catch wholesale app loading
      calculateWholesaleSqm();
      setTimeout(calculateWholesaleSqm, 300);
    }
  })();
